// Whole-collection OOS-last sort + AJAX pagination.
// 1. On collection page load: fetch server pages (parallel, batched) only until
//    there is enough data to render the CURRENT page correctly, classify cards by
//    the `aef-card--oos` class Liquid puts on the card root (chữ "sold" chỉ còn
//    là đường dự phòng), sort in-stock first then OOS.
// 2. Cache result in sessionStorage by pathname+sort_by (5 min TTL), resumable.
// 3. Once the rest has been prefetched at idle, pagination link clicks are served
//    from cache → instant <50ms navigation, no server round-trip.
(function () {
  'use strict';
  /* 🔴 24/10/2026 (vòng 53 · đợt 5b · B2 — phương án (a)) — PHẦN CHUNG VỚI KHỐI INLINE.
   * Khối inline ngay trên #ProductGridContainer (sections/main-collection-product-grid.liquid)
   * chạy lúc phân tích HTML, TRƯỚC tệp `defer` này, và giữ MỘT bản công thức khoá bộ đệm
   * + hạn bộ đệm: nó cần khoá để quyết "ẩn lưới chờ bản đã sắp" ở lượt tải lại / Lùi. Tệp
   * này gọi CHÍNH hàm đó (tinhCacheKey bên dưới), không chép công thức — hai bản chép là
   * ngày nào đổi một bên, khối inline tìm nhầm khoá ⇒ không bao giờ ẩn (hoặc ẩn theo bộ
   * đệm của trạng thái lọc khác) mà không ai hay.
   * Không có khối đó (section bị sửa mất) thì tệp này KHÔNG có khoá để phân biệt trạng thái
   * lọc ⇒ không sắp gì cả, nói ra ở console, để lưới máy chủ đứng nguyên — trộn dữ liệu đã
   * lọc với chưa lọc tệ hơn nhiều so với không sắp. Người gác bắt việc mất khối:
   * scripts/test-luoi-khong-doi-duoi-tay-khach.js (đọc khối từ section, thiếu là RỚT). */
  var CHUNG = window.__aefOosSort;
  if (!CHUNG || typeof CHUNG.khoa !== 'function') {
    try { console.warn('[collection-oos-sort] thiếu khối inline window.__aefOosSort — không sắp hàng hết xuống cuối.'); } catch (e) {}
    return;
  }
  if (!/^\/collections\/[^/]+\/?$/.test(location.pathname)) { CHUNG.hien(); return; }
  /* 🔴 5/9/2026 (vòng 42) — `let`, KHÔNG CÒN `const`.
   * Tick một ô lọc (hoặc đổi ô "Sort by") là assets/facets.js thay NGUYÊN ruột
   * #ProductGridContainer, nên cái node `#product-grid` chụp ở dòng dưới bị vứt khỏi
   * tài liệu ngay lượt lọc ĐẦU TIÊN. Bản cũ chụp một lần rồi cầm cái xác đó tới hết
   * phiên: mọi renderPage() sau đó ghi vào hư không. Đường đi của khách và cách vá
   * nằm ở khối chú thích của khoiDongLai() gần cuối file. */
  let grid = document.getElementById('product-grid');
  if (!grid) return;

  /* Trang hiện tại LUÔN đọc lại được từ URL, không giữ một con số chụp lúc tải trang:
   * sau mỗi lượt lọc, facets.js đã đẩy URL mới (nó luôn bỏ `page`) rồi mới tới lượt
   * mình. Kẹp về 1 khi `?page=` là rác — `parseInt('abc')` ra NaN, mà NaN lọt vào
   * haveEnoughFor()/renderPage() thì ra lưới rỗng trong im lặng.
   * 🔴 24/10/2026 (B2 vòng 2, N4) — phép đọc này sống ở khối inline (CHUNG.trang): khối đó quyết ẩn/vẽ
   * trang nào lúc phân tích HTML, hai bản chép là hai câu trả lời cho "đang ở trang mấy". */
  function trangTuUrl() { return CHUNG.trang(); }
  let currentPage = trangTuUrl();
  let sectionId = grid.dataset.id || 'product-grid';

  /* 🔴 15/9/2026 (vòng 49) — TÀI LIỆU NÀY CÓ TỪNG LÀ TRANG 1 KHÔNG?
   * Chụp NGAY đây, trước khi bất cứ ai đổi URL (mình pushState, facets đẩy URL).
   * Bốn khối chỉ-thuộc-trang-1 nằm NGOÀI #ProductGridContainer và chỉ được máy chủ
   * dựng khi `current_page == 1`; vào thẳng `?page=2` là chúng KHÔNG CÓ trong tài
   * liệu, và không mã nào trong tệp này gọi chúng về được. Xem duPhanNgoaiLuoi(). */
  var taiTrangGocLaMot = trangTuUrl() === 1;

  /* 5/9/2026 (vòng 42) — SỐ LƯỢT, đổi mỗi lần lưới bị thay.
   * Mọi lượt fetch đang bay đọc lại số này sau khi await xong; khác số là bỏ kết quả
   * chứ không nhét vào bộ dữ liệu mới. Thiếu chốt này thì lô trang CHƯA LỌC về muộn
   * sẽ dồn vào mảng ĐÃ LỌC rồi được ướp dưới khoá đã lọc — đúng cái kiểu "một khái
   * niệm, hai nguồn" mà khoá v3 sinh ra để chặn. */
  let luot = 0;

  /* ══ 🔴 14/9/2026 (vòng 48) — KHÔNG THAY LƯỚI DƯỚI TAY KHÁCH ════════════════
   *
   * BỆNH. Máy chủ và tệp này chia trang bằng HAI phép khác nhau: Liquid cắt trang
   * theo thứ tự bộ sưu tập rồi mới đẩy hàng-hết xuống cuối TRONG từng trang
   * (hai vòng for `product.available` của sections/main-collection-product-grid.liquid), còn renderPage() cắt
   * trang từ danh sách đã sắp TOÀN bộ sưu tập. Hai phép chỉ trùng nhau chừng nào
   * các trang phía trước chưa có món nào hết hàng. Đo LIVE, đếm thẻ trùng vị trí:
   *     /collections/vietnamese  trang 1 → 19/24 · trang 2 → 16/24 · trang 5 → 0/24
   *     /collections/snacks      trang 1 → 13/24   (11 thẻ đổi món ngay trang đầu)
   * Lưới máy chủ hiện NGAY (`oos-sort-ready` không có một luật CSS nào — cổng
   * opacity đã bị gỡ có chủ ý, xem khối chú thích ngay dưới thẻ nạp tệp này ở đầu
   * sections/main-collection-product-grid.liquid), rồi
   * 0,7-4 giây sau init() ghi đè nguyên lưới. Khách đang đưa ngón tay tới nút "+"
   * của một thẻ thì thẻ đó đổi món dưới tay — sai món vào giỏ, không dấu hiệu nào.
   *
   * VÌ SAO KHÔNG BỎ SẮP XẾP ĐI CHO XONG. Boss chốt: hàng hết phải xuống cuối TOÀN
   * bộ sưu tập chứ không phải từng trang (memory/project_oos_sort.md) — đó là lý do
   * tệp này tồn tại. Mà hai phép chia thì KHÔNG THỂ trùng nhau về mặt số học. Nên
   * câu hỏi còn lại chỉ là: cú ghi đè rơi vào lúc khách CHƯA kịp chạm, hay ĐÃ chạm.
   *
   * LUẬT MỚI. Lượt ghi đè LẠNH chỉ được phép khi nó còn nằm trong khoảng "đang
   * tải": trong NGAN_DOI_MS kể từ đầu lượt VÀ khách chưa bấm/chạm/gõ vào lưới.
   * (23/10/2026, LU2: lượt đè của nhánh BỘ ĐỆM cũng đè lên lưới máy chủ mà trước đó
   * không qua cổng nào; nay cả hai qua chung duocDeLuoiMayChu(), thêm vế VỊ TRÍ —
   * xem khachDaThayODoi().) Quá đó thì máy chủ giữ trang NÀY; dữ
   * liệu vẫn lấy nốt và vẫn ướp lại, nên mọi lượt điều hướng SAU (bấm số trang,
   * popstate, hay một lượt tải trang mới) vẫn dựng đúng thứ tự đã sắp.
   *
   * CON SỐ 1200. Đo LIVE: một lượt `?section_id=…` của lưới mất 0,66-0,82s. Trang 1
   * chỉ cần MỘT lô (2 trang gọi song song) ⇒ ~0,8s, lọt qua. Trang xa cần 2-3 lô
   * TUẦN TỰ ⇒ 1,5-4s, bị chặn — mà đó đúng là những trang lệch nặng nhất (0/24).
   * Ngưỡng này canh "CÒN KỊP KHÔNG", cố ý KHÔNG canh "lệch nhiều hay ít": canh theo
   * độ lệch thì trang càng nhiều hàng hết — đúng lúc sắp xếp có giá trị nhất — lại
   * càng bị tắt, tức tự tay tắt chính tính năng này.
   *
   * ⚠️ THỨ CHƯA ĐÓNG ĐƯỢC Ở ĐÂY: lượt giữ-bản-máy-chủ rồi bấm sang trang sau thì
   * trang sau là bản ĐÃ SẮP, nên vài món nằm giữa hai phép chia bị nhảy qua. Ranh
   * giới đó đã có sẵn từ trước bản vá này (mọi lượt `haveEnoughFor` trượt đều rơi
   * đúng vào nó); đóng hẳn thì phải đẩy "hết hàng xuống cuối" xuống TẦNG DỮ LIỆU —
   * ngoài phạm vi tệp này.
   *
   * Người gác: scripts/test-luoi-khong-doi-duoi-tay-khach.js */
  var NGAN_DOI_MS = 1200;
  var mocDoi = Date.now();      // đầu lượt dựng hiện tại (đặt lại sau mỗi lượt lọc)
  var daChamLuoi = false;       // khách đã bấm/chạm/gõ vào lưới trong lượt này chưa

  /* Nghe ở `document` với cờ bắt, KHÔNG gắn vào `grid`: facets.js thay nguyên ruột
     #ProductGridContainer nên mọi người nghe gắn thẳng vào lưới đều chết theo lượt
     lọc đầu tiên — đúng cái bẫy đã ghi ở khối chú thích của khoiDongLai(). */
  function ghiNhanCham(e) {
    const t = e && e.target;
    if (t && t.closest && t.closest('#product-grid')) daChamLuoi = true;
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ten) {
    document.addEventListener(ten, ghiNhanCham, true);
  });

  function conKipDeLen() {
    return !daChamLuoi && (Date.now() - mocDoi) <= NGAN_DOI_MS;
  }

  /* ══ 🔴 23/10/2026 (vòng 53 · đợt 5b · LU2) — CỔNG THEO VỊ TRÍ, CHO CẢ HAI LƯỢT ĐÈ ══
   *
   * BỆNH. Cổng thời gian + "đã chạm" ở trên chỉ đứng trước lượt đè LẠNH. Nhánh BỘ
   * ĐỆM PHIÊN của init() gọi renderPage() thẳng — mà đó đúng là nhánh của mọi lượt
   * TẢI LẠI (F5, kéo để làm mới) trong 5 phút còn bộ đệm, và mọi lượt Lùi khi bfcache
   * trượt. Trình duyệt khôi phục vị trí cuộn TRƯỚC khi tệp `defer` này chạy, nên khách
   * đang nhìn giữa lưới máy chủ thì ~0,15-0,3 s sau khung đã cuộn đầu tiên, lưới bị
   * thay. Đo LIVE 18/10 (tải lại khi đang cuộn, có bộ đệm):
   *     🖥 /collections/snacks 9/9 ô trong khung đổi món · 🖥 /collections/all 6/9
   *     📱 /collections/snacks 6/6
   * Trang ≥2 thì thẻ bị thay còn hàng, nút thêm đang bật ⇒ bấm trong cửa sổ đó là
   * thêm NHẦM món. Cổng thời gian cũng không cứu được lượt LẠNH khi khách đã cuộn sẵn
   * (tải lại sau khi bộ đệm hết hạn) hay đang cuộn bánh xe — bánh xe không phải "chạm".
   *
   * LUẬT. Trước MỌI lượt đè lên lưới máy chủ vừa vẽ (nhánh bộ đệm lẫn nhánh lạnh), tìm
   * Ô ĐẦU TIÊN sẽ đổi món. Khách ĐANG THẤY hoặc ĐÃ LƯỚT QUA ô đó (mọi ô sau nó nằm
   * thấp hơn) thì máy chủ giữ trang này — đúng nhánh "hết kịp" của cổng thời gian:
   * firstPaint = false, vẫn bindPagination/saveCache/prefetchRest, nên mọi lượt điều
   * hướng SAU vẫn dựng thứ tự đã sắp. Ô đổi còn nằm dưới mép khung thì đè như cũ: khách
   * chưa thấy gì đổi, hàng hết vẫn xuống cuối TOÀN bộ sưu tập.
   *
   * VÌ SAO KHÔNG ẨN LƯỚI CHỜ JS (nói chung). Cổng opacity đã bị gỡ có chủ ý (LCP, lưới
   * trống tới ~10 s — xem đầu sections/main-collection-product-grid.liquid).
   * 🔴 24/10/2026 (B2, Boss chốt phương án (a)) — MỘT ngoại lệ hẹp: lượt `reload` /
   * `back_forward` CÓ bộ đệm còn hạn và đủ cho trang đang xem thì khối inline của section
   * ẩn RIÊNG lưới (visibility, giữ chỗ) ≤ 800 ms; nhánh bộ đệm của init() vẽ thẳng bản đã
   * sắp rồi gỡ ẩn ⇒ khách chỉ thấy MỘT bản, không có cú đổi nào để chặn. Lý do: ô 0 của
   * trang ≥2 luôn đổi ⇒ cổng vị trí bên dưới giữ bản máy chủ ở MỌI lượt tải lại / Lùi trang
   * ≥2 (10-15 thẻ hết hàng, Lùi về thì khác món khách vừa xem, bấm sang trang sau thì hụt
   * món). Cổng vị trí này vẫn là đường DỰ PHÒNG: lưới đã hiện (quá hạn chót, không bộ đệm,
   * lượt vào đầu đang cuộn) thì nó quyết như cũ.
   *
   * 🪤 THẺ KHÔNG CÓ HỘP BỐ CỤC (cao 0: lưới display:none, môi trường không dàn trang)
   *    thì không ai nhìn thấy nó ⇒ không chặn.
   * 🪤 HANDLE RỖNG (layHandle không đọc nổi markup) tính là ĐỔI ở đúng ô đó: không biết
   *    ô nào đổi thì hỏi vị trí sớm nhất, đừng đoán là trùng.
   * 🪤 CHỈ HỎI VỊ TRÍ KHI KHÁCH CÓ THỂ ĐANG NHÌN GIỮA LƯỚI: trình duyệt khôi phục cuộn
   *    (lượt `reload` / `back_forward`) hoặc trang ĐANG cuộn (y > 0) lúc quyết. Lượt
   *    VÀO ĐẦU ở đầu trang giữ đúng luật vòng 48 (giờ + chạm). 🔴 Bản đầu của LU2 hỏi vị
   *    trí ở MỌI lượt kèm biên ⇒ người soi đo LIVE 🖥1920×1080 lượt vào đầu: on-sale trang
   *    1 giữ bản máy chủ, 18/24 thẻ HẾT HÀNG (bản 94beaaca sắp đúng); mất sắp ở mọi khung
   *    cao ≳1006 px (dried-fruits ≳1157 px, máy tính bảng dọc cũng dính). Chú thích cũ ở
   *    đây ("0 danh mục mất sắp xếp") suy từ hình học snacks 1280/390 — SAI.
   * 🪤 BIÊN DƯỚI = nửa khung nhìn, CHỈ khi đang cuộn (y > 0): tệp này đọc vị trí trên
   *    luồng chính, còn cuộn quán tính (bánh xe lúc đang tải — người soi đo 8×420 px)
   *    chạy ở luồng hợp thành nên có thể đã đi trước vài khung hình. Ở y = 0 (tải lại /
   *    Lùi về đầu trang) không có cú cuộn nào đang chạy ⇒ chỉ chặn ô ĐANG trong khung,
   *    để khung cao (🖥1920, máy tính bảng) không mất sắp xếp vì một ô khách chưa thấy.
   * 🪤 KHÔNG đặt trong renderPage(): navigateTo() và popstate cũng gọi nó, mà ở đó
   *    khách vừa BẤM sang trang khác — nội dung mới là đúng thứ khách đòi.
   * 🪤 CHỈ HỎI VỊ TRÍ Ở LƯỢT TẢI TRANG (hoiViTri), KHÔNG hỏi ở đường LỌC / Sort by
   *    (khoiDongLai). Ở đó facets.js vừa thay cả lưới theo cú bấm của khách, và vòng 48
   *    đã cố ý cho lượt sắp chạy lại trong NGAN_DOI_MS ("regardless of filter" — Boss).
   *    Đo 23/10 LIVE: đổi Sort by → price-ascending khi đang ở gần lưới (🖥 y=584, 📱
   *    y=731) mà hỏi vị trí thì trang 1 KHÔNG được sắp (17/24 ô lệch bản đã sắp). Đó là
   *    đổi hành vi chưa ai bàn ⇒ để nguyên, ghi vào báo cáo cho Boss/người soi.
   *
   * Người gác: scripts/test-luoi-khong-doi-duoi-tay-khach.js (⑥-⑬, jsdom dàn trang giả;
   * ⑤b canh đường lọc không bị hỏi vị trí; ⑪ lượt vào đầu khung cao vẫn sắp; ⑩ biên khi
   * đang cuộn; ⑬ trang 2 hỏi đúng lát cắt của trang 2) · scripts/test-luoi-tai-lai-dang-cuon-khong-
   * doi-mon.js (trình duyệt thật, LIVE). */
  var BIEN_DUOI_KHUNG = 0.5;
  var hoiViTri = true;          // lượt tải trang: có. khoiDongLai (lọc / Sort by): không.
  /* Trình duyệt có KHÔI PHỤC vị trí cuộn cho lượt tải này không (tải lại · Lùi/Tiến mà
     bfcache trượt). Chụp một lần: loại điều hướng không đổi trong đời tài liệu. */
  var khoiPhucCuon = (function () {
    try {
      var n = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (n && n.type) return n.type === 'reload' || n.type === 'back_forward';
      var cu = performance.navigation;   // trình duyệt cũ: 1 = reload · 2 = back_forward
      return !!cu && (cu.type === 1 || cu.type === 2);
    } catch (e) { return false; }
  })();
  function cuonHienTai() {
    return window.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || 0;
  }
  function khachDaThayODoi(wanted, bien) {
    const items = grid.querySelectorAll('.grid__item');
    const n = Math.max(items.length, wanted.length);
    let i = 0;
    while (i < n && items[i] && wanted[i]) {
      const h = layHandle(items[i]);
      if (!h || h !== wanted[i].handle) break;
      i++;
    }
    if (i >= n) return false;                              // không ô nào đổi
    // Lưới máy chủ NGẮN hơn: ô đổi đầu tiên mọc ra ngay dưới ô cuối của nó.
    const el = items[i] || items[items.length - 1];
    if (!el) return false;
    const r = el.getBoundingClientRect();
    if (!(r.height > 0)) return false;
    const mep = items[i] ? r.top : r.bottom;
    const cao = window.innerHeight || document.documentElement.clientHeight || 0;
    return mep < cao * (1 + bien);
  }

  /* MỘT cổng cho cả hai lượt đè lên lưới máy chủ (nhánh bộ đệm · nhánh lạnh). */
  function duocDeLuoiMayChu(pageNum) {
    if (!conKipDeLen()) return false;
    if (!hoiViTri) return true;
    const y = cuonHienTai();
    // Lượt vào đầu, đang ở đầu trang: luật vòng 48 (giờ + chạm) — xem khối chú thích trên.
    if (!khoiPhucCuon && !(y > 0)) return true;
    // Chưa đủ dữ liệu thì renderPage() tự từ chối — chưa có ô nào sắp đổi để hỏi.
    if (!haveEnoughFor(pageNum)) return true;
    return !khachDaThayODoi(latTrang(pageNum), y > 0 ? BIEN_DUOI_KHUNG : 0);
  }

  function reveal() {
    document.documentElement.classList.add('oos-sort-ready');
    CHUNG.hien();   // B2 (a): gỡ lớp ẩn lưới của khối inline (không ẩn thì vô hại)
  }

  /* Bộ đệm phiên, sống qua các lượt điều hướng. Khoá = collection + MỌI trạng thái
   * lọc/sắp xếp (xem v3 bên dưới).
   *
   * v2: bộ đệm có thể là bộ ĐANG DỞ (mới lấy k trang đầu), nên phải mang theo
   * `pages` + `complete`. Bản v1 không có hai trường đó; đọc bản v1 bằng luật mới
   * sẽ tưởng nó đủ và sắp xếp thiếu, nên đổi khoá để bỏ qua hẳn bộ đệm cũ.
   *
   * v3 (2026-08-16) — KHOÁ PHẢI MANG THEO BỘ LỌC.
   *
   * v2 chỉ gồm pathname + sort_by. Mọi `filter.v.availability`, `filter.v.price.gte`,
   * `filter.v.price.lte` (đúng 3 bộ lọc staging đang phát) đều KHÔNG vào khoá —
   * trong khi fetchPage() lại dựng URL bằng `new URL(location.href)` nên dữ liệu
   * lấy về CÓ mang bộ lọc. Tức bộ đệm lưu dữ liệu ĐÃ LỌC dưới cái tên của trang
   * CHƯA LỌC, và ngược lại. Hai chiều đều hỏng, cả hai đều im lặng:
   *   · Lượt đầu vào URL sạch → prefetchRest() lấy đủ 17 trang → complete = true,
   *     ướp 5 phút. Lượt sau vào URL CÓ lọc: loadCache() trúng khoá cũ,
   *     haveEnoughFor() thấy complete → renderPage() đè lưới ĐÃ LỌC mà máy chủ
   *     vừa dựng bằng lô 24 sản phẩm CHƯA LỌC.
   *   · Lượt đầu vào URL có lọc → bộ đệm chỉ có vài chục thẻ đã lọc. Lượt sau vào
   *     URL sạch: renderPage(2) cắt `sorted.slice(24,48)` ra mảng RỖNG → return
   *     false, mà bindPagination() đã preventDefault() rồi ⇒ bấm số trang KHÔNG
   *     xảy ra gì hết.
   *
   * Lấy MỌI tham số trừ `page` (page là thứ khoá này phục vụ, không phải thứ định
   * danh nó), sắp xếp để thứ tự gõ trên URL không đẻ ra hai khoá cho cùng một
   * trạng thái. Đổi v2 → v3 để bỏ hẳn bộ đệm cũ đang nằm trong sessionStorage của
   * khách — giữ v2 là lượt đầu sau khi vá vẫn ăn phải dữ liệu bẩn.
   *
   * 🔴 5/9/2026 (vòng 42) — KHOÁ PHẢI TÍNH LẠI ĐƯỢC, KHÔNG CHỤP MỘT LẦN.
   * Công thức trên đúng, nhưng nó chạy đúng MỘT lần lúc tải trang. Lọc bằng facets
   * KHÔNG tải lại trang — nó chỉ đổi URL và thay lưới — nên từ giây đó khoá đang cầm
   * là tên của trạng thái CŨ, còn dữ liệu fetchPage() lấy về (dựng từ `location.href`)
   * là của trạng thái MỚI. Đúng hai chiều trộn dữ liệu mà v3 đã sinh ra để chặn, chỉ
   * khác là lần này xảy ra TRONG CÙNG MỘT LƯỢT XEM. Nay là một hàm: ai đổi URL thì
   * gọi lại (khoiDongLai) và so được khoá của URL với khoá của bộ đang cầm (popstate).
   *
   * 🔴 24/10/2026 (B2) — CÔNG THỨC (mọi tham số trừ `page`, sắp xếp, tiền tố v3) và HẠN
   * 5 phút nay sống ở khối inline của section (window.__aefOosSort) — xem đầu tệp. */
  function tinhCacheKey() { return CHUNG.khoa(); }
  let CACHE_KEY = tinhCacheKey();
  const CACHE_TTL = CHUNG.hanBoDem;

  /* Trạng thái: thẻ đã lấy được, theo ĐÚNG thứ tự collection, của các trang 1..pagesFetched */
  let cachedAll = null;
  let cachedPageSize = 0;   // 0 = chưa biết; suy ra từ trang dài nhất đã lấy
  let pagesFetched = 0;     // trang cuối của dải LIỀN MẠCH đã lấy được
  let complete = false;
  /* 🔴 30/10/2026 (người soi 0bf6975f) — MỐC CỦA BỘ ĐỆM LÀ LÚC LẤY DỮ LIỆU, KHÔNG PHẢI LÚC GHI.
     Hạn 5 phút là hạn của THẺ: giá, tồn, data-max-qty trên thẻ vẽ lại. Bản cũ đóng dấu Date.now() ở mỗi lần
     saveCache(), mà nhánh bộ đệm lưu lại ở MỌI lượt tải (prefetchRest) ⇒ khách quay lại dưới 5 phút một lần thì hạn
     không bao giờ tới: lần tải lại thứ 5 của người soi vẽ thẻ 1.450 giây tuổi với 0 lượt mạng. Nay giữ mốc đã nạp;
     nối thêm trang vào bộ cũ cũng giữ, vì hạn phải bao được thẻ CŨ NHẤT. 0 = chưa có bộ nào, lần lưu đầu đóng dấu. */
  let cacheT = 0;
  let firstPaint = true;    // lượt renderPage đầu = sắp lại thứ tự, KHÔNG cho nhả theo nhóm
  /* 🔴 14/9/2026 (vòng 48) — "pagesFetched > 0" KHÔNG CÒN NGHĨA LÀ "ĐÃ ĐI MẠNG".
     Từ khi gieoTuLuoi() đặt pagesFetched = 1 bằng thẻ có sẵn trong trang, hai khái
     niệm đó tách đôi. ensureEnoughFor() vẫn cần biết "đây có phải lô mạng ĐẦU TIÊN
     không" để chọn cỡ lô; đọc nhầm qua pagesFetched là lô đầu nhảy từ 2 lên 4 trang
     (FIRST_BATCH→NEXT_BATCH) — đúng những collection nhiều hàng hết mới rơi vào
     nhánh này, tức tốn gấp đôi ở chỗ vốn đã tốn nhất. Nên có cờ riêng. */
  let daGieoTuDom = false;

  /* ══ 🔴 24/10/2026 (B2 vòng 2, N2) — PHIÊN ĐANG ĐI THEO PHÉP CHIA CỦA MÁY CHỦ ══════════════
   * giuMayChu = lưới đang bày KHÁC lát cắt đã sắp của trang này (init() giữ bản máy chủ: không bộ
   * đệm mà dữ liệu về muộn / khách đã chạm / cổng vị trí; hoặc dấu của trang trước). Hỏi KẾT QUẢ (lưới
   * đang bày gì), không hỏi nhánh nào đã chạy: khối VẼ của section có thể đã thay lưới bằng bản đã sắp
   * trước khi tệp này chạy, lúc đó dù cổng có "giữ" thì lưới vẫn là bản đã sắp.
   * Dấu (sessionStorage, tên riêng — KHÔNG mang tiền tố `oos-sort:` của bộ đệm) chỉ sống cho ĐÚNG một
   * lượt tải: cùng khoá bộ lọc, đúng trang đích, trong 60 s; đọc là xoá. */
  let giuMayChu = false;
  const KHOA_DAU_MAY_CHU = 'aef-oos-giu-may-chu';
  function datDauGiuMayChu(trangDich) {
    try { sessionStorage.setItem(KHOA_DAU_MAY_CHU, JSON.stringify({ khoa: CACHE_KEY, trang: trangDich, t: Date.now() })); } catch (e) {}
  }
  function docDauGiuMayChu() {
    try {
      const raw = sessionStorage.getItem(KHOA_DAU_MAY_CHU);
      if (!raw) return false;
      sessionStorage.removeItem(KHOA_DAU_MAY_CHU);
      const d = JSON.parse(raw);
      return !!d && d.khoa === CACHE_KEY && d.trang === currentPage && Math.abs(Date.now() - d.t) < 60000;
    } catch (e) { return false; }
  }
  function luoiLaBanDaSap(pageNum) {
    if (!haveEnoughFor(pageNum)) return false;
    const can = latTrang(pageNum).map((c) => c.handle);
    const dang = Array.from(grid.querySelectorAll('.grid__item')).map(layHandle);
    return can.length === dang.length && can.every((h, i) => !!h && h === dang[i]);
  }

  /* Cỡ trang phải SUY RA từ máy chủ, không được đoán sẵn 24: theme đổi số sản
   * phẩm mỗi trang là renderPage() cắt sai nhịp với thanh phân trang. Lấy trang
   * dài nhất trong các trang đã tải (trang cuối luôn ngắn hơn). */
  function pageSize() { return CHUNG.coTrang(cachedPageSize); }   // 24/10 (B2 vòng 2): mặc định 24 ở khối inline

  function loadCache() {
    try {
      /* B2 (a): ở lượt tải lại / Lùi, khối inline ĐÃ phân tích đúng chuỗi này để quyết có ẩn
         lưới không — dùng lại (một lần, và chỉ khi cùng khoá) thay vì phân tích lần hai
         vài trăm KB trên luồng chính. */
      const san = CHUNG.boDem;
      CHUNG.boDem = null;
      let d = san && san.khoa === CACHE_KEY ? san.d : null;
      if (!d) {
        const raw = sessionStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        d = JSON.parse(raw);
      }
      if (Date.now() - d.t > CACHE_TTL) return null;
      return d;
    } catch (e) { return null; }
  }
  function saveCache() {
    if (!cachedAll || !cachedAll.length) return;
    if (!cacheT) cacheT = Date.now();
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        t: cacheT, cards: cachedAll, pageSize: cachedPageSize,
        pages: pagesFetched, complete: complete
      }));
    } catch (e) {}
  }

  /* ══ 🔴 14/9/2026 (vòng 48) — MỘT LUẬT PHÂN LOẠI, DÙNG CHUNG CHO CẢ HAI NGUỒN ══
   *
   * Từ hôm nay thẻ vào `cachedAll` đến từ HAI nơi: HTML lấy qua mạng (fetchPage) và
   * lưới máy chủ ĐÃ DỰNG SẴN trong trang (gieoTuLuoi). Chép luật phân loại ra hai
   * chỗ là đẻ đúng họ lỗi "một khái niệm, hai nguồn dữ liệu" của kho: ngày nào Liquid
   * đổi tên lớp `aef-card--oos`, một đầu hiểu còn đầu kia không, và thứ tự sắp xếp
   * sai trong im lặng — không lỗi, không log. Nên chỉ được có ĐÚNG ba hàm dưới đây,
   * và cả hai đường đều đi qua chúng.
   * 🔴 24/10/2026 (B2 vòng 2) — layHandle nay là CHUNG.handle: khối vẽ của section cũng so handle (bỏ
   * lượt ghi khi lưới đã trùng) — một phép đọc handle cho cả ba người dùng. */
  function layHandle(item) { return CHUNG.handle(item); }
  function docThe(item) {
    /* 2026-08-17 — ĐỌC TRẠNG THÁI, KHÔNG ĐỌC CHỮ.
       Bản cũ dò /sold/i trên textContent của badge. Nó chạy được chỉ vì badge
       luôn in tiếng Anh; đúng ngày nhãn đó được dịch (hoặc locale Shopify đổi)
       là cả bộ sắp xếp hàng-hết-xuống-cuối chết trong im lặng — không lỗi,
       không log, chỉ là thứ tự sai. Nay Liquid khai thẳng `aef-card--oos` /
       `.soldout__price`; đường dò chữ giữ lại làm dự phòng cho HTML cũ còn
       nằm trong bộ nhớ đệm trình duyệt. */
    const badge = item.querySelector('.card__badge');
    const text = (badge && badge.textContent) || '';
    const soldOut =
      !!item.querySelector('.aef-card--oos, .card__badge.soldout__price') ||
      /sold/i.test(text);
    return { handle: layHandle(item), html: item.outerHTML, soldOut };
  }
  /* Thẻ của MỘT trang, lấy trong phạm vi chính cái lưới. Bản cũ hỏi `.grid__item`
     trên cả tài liệu do DOMParser dựng; bó lại trong #product-grid để hai nguồn đếm
     bằng cùng một phép — lưới trong trang cũng chỉ đếm được trong phạm vi nó. */
  function docLuoi(root) {
    if (!root) return [];
    const items = root.querySelectorAll('.grid__item');
    return Array.from(items).map(docThe);
  }

  async function fetchPage(pageNum) {
    const u = new URL(location.href);
    u.searchParams.set('page', pageNum);
    u.searchParams.set('section_id', sectionId);
    const res = await fetch(u.toString(), { credentials: 'same-origin' });
    // null = KHÔNG lấy được trang này, khác hẳn [] = trang này rỗng thật. Hai thứ
    // đó bản cũ gộp làm một, và đó là gốc của lỗi mất hàng ở fetchAllPages().
    if (!res.ok) return null;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return docLuoi(doc.getElementById('product-grid') || doc);
  }

  /* Số trang THẬT do máy chủ ghi vào #product-grid (xem
   * sections/main-collection-product-grid.liquid). Bản cũ không đọc con số này mà
   * DÒ: gọi từng lô 8 trang cho tới khi gặp một lô rỗng hoàn toàn. Hệ quả đo được
   * trên /collections/vietnamese (414 SP = 18 trang) ngày 13/8: 32 request, tức
   * 14 request gọi vào những trang KHÔNG TỒN TẠI — 44% số lần gọi chỉ để biết
   * "hết trang rồi", trong khi câu trả lời đã nằm sẵn trong HTML mà trình duyệt
   * vừa tải xong.
   *
   * Vẫn giữ đường dò làm dự phòng: nếu trang đang xem là bản HTML cũ còn nằm
   * trong bộ nhớ đệm của trình duyệt (chưa có thuộc tính này) thì script phải
   * chạy được y như trước, không được thành sắp xếp cụt. */
  function serverTotalPages() {
    const n = parseInt(grid.dataset.totalPages || '', 10);
    return Number.isFinite(n) && n >= 1 ? n : 0;
  }

  /* ══ 🔴 14/9/2026 (vòng 48) — TRANG 1 ĐANG NẰM TRONG TAY, ĐỪNG ĐI XIN LẠI ══════
   *
   * BỆNH. Đường LẠNH của init() vào ensureEnoughFor() với `pagesFetched = 0`, nên
   * lô đầu là fetchRange(1, 2) — tức fetchPage(1) ĐI LẤY LẠI đúng 24 thẻ mà trình
   * duyệt vừa phân tích xong và khách đang nhìn. Đo LIVE 14/9 trên
   * /collections/vietnamese?page=1&section_id=template--26852600906034__product-grid:
   * 344.993 byte thô / 26.994 byte gzip, 24 thẻ `.grid__item`, 5 thẻ hết hàng. Đặt
   * cạnh /collections/vietnamese lấy cùng lúc: ruột #product-grid TRÙNG KHÍT tới
   * từng byte (294.393 = 294.393), cùng 24 handle, cùng thứ tự, cùng 5 thẻ hết hàng.
   * Header của URL section là `cdn-cache-control: no-cache, no-store` +
   * `cf-cache-status: DYNAMIC` ⇒ không bộ đệm HTTP nào cứu, mọi lượt xem danh mục
   * đều trả tiền: ~27 KB đường truyền 4G + một lượt DOMParser 345 KB CHẶN LUỒNG
   * CHÍNH, đúng lúc ảnh LCP đang tải. Cùng 24 thẻ đó nằm sẵn trong DOM, miễn phí.
   * (Số trôi theo giờ vì kho đổi — lượt đo của người soi ra 335.659 byte; cùng độ
   * lớn, cùng kết luận.)
   *
   * 🪤 CHỈ GIEO Ở TRANG 1. `pagesFetched = N` là lời khai "đã có LIỀN MẠCH trang
   * 1..N". Khách vào thẳng `?page=3` mà gieo `pagesFetched = 3` bằng 24 thẻ của
   * RIÊNG trang 3 là tự tay đục thủng bộ dữ liệu: fetchRange() sẽ nhận trang 4 (vì
   * `r.p === pagesFetched + 1`), renderPage(3) cắt `sorted.slice(48, 72)` trên một
   * mảng bắt đầu bằng thẻ trang 3, rồi saveCache() ƯỚP cái bộ thủng ấy 5 phút —
   * đúng thảm hoạ mà khối chú thích của fetchRange() dựng ra để chặn. Trang 2 trở
   * đi giữ nguyên đường cũ.
   *
   * 🪤 CỜ RIÊNG, KHÔNG SUY QUA pagesFetched: xem chú thích ở chỗ khai `daGieoTuDom`.
   *
   * Người gác: scripts/test-danh-muc-khong-tai-lai-trang-mot.js */
  function gieoTuLuoi() {
    if (trangTuUrl() !== 1) return false;
    if (pagesFetched || (cachedAll && cachedAll.length)) return false;
    /* 🔴 24/10/2026 (B2 vòng 2) — khối vẽ của section ĐÃ thay lưới bằng bản đã sắp lúc phân tích HTML
       ⇒ DOM lúc này KHÔNG còn là trang 1 của máy chủ: gieo nó là khai "trang 1 = các món này" sai — hàng
       hết của trang 1 máy chủ sẽ không bao giờ được lấy. (Chỉ xảy ra khi init() không dùng được bộ đệm
       mà khối vẽ vừa dùng — hết hạn đúng ở ranh giới.) Lấy trang 1 qua mạng như trang 2 trở đi. */
    if (grid.hasAttribute('data-aef-ve-som')) return false;
    const the = docLuoi(grid);
    if (!the.length) return false;
    cachedAll = the;
    cachedPageSize = the.length;
    pagesFetched = 1;
    daGieoTuDom = true;
    // Cùng một phép chốt "hết trang" của fetchRange(): collection một trang thì gieo
    // xong là xong, khỏi vào vòng lặp chỉ để phát hiện không còn gì mà lấy.
    const known = serverTotalPages();
    if (known && pagesFetched >= known) complete = true;
    return true;
  }

  function inStockCount() {
    if (!cachedAll) return 0;
    let n = 0;
    for (const c of cachedAll) if (!c.soldOut) n++;
    return n;
  }

  /* Đã đủ dữ liệu để dựng ĐÚNG trang `pageNum` chưa?
   *
   * Chứng minh: thứ tự sau sắp xếp = [mọi SP còn hàng, theo thứ tự collection] rồi
   * mới tới [mọi SP hết hàng]. Các SP còn hàng lấy từ k trang ĐẦU chính là k×24 SP
   * còn hàng ĐẦU TIÊN của cả collection — không SP nào ở trang sau chen lên trước
   * được. Nên chỉ cần số SP còn hàng đang có ≥ vị trí cuối của trang muốn dựng là
   * đoạn đó đã chốt, lấy thêm trang nữa cũng không đổi.
   *
   * Lấy hết rồi (complete) thì luôn dựng được, kể cả trang toàn hàng hết. */
  function haveEnoughFor(pageNum) {
    /* 24/10/2026 (B2 vòng 2, N4): phép "đủ" sống ở khối inline (CHUNG.du) — khối đó dùng ĐÚNG phép này
       để quyết ẩn lưới; hai bản chép lệch nhau là ẩn mà không vẽ được (hoặc ngược lại). */
    return CHUNG.du(cachedAll, pageSize(), complete, pageNum);
  }

  /* ══ 🔴 25/9/2026 (vòng 53) — MỘT SẢN PHẨM, MỘT THẺ ═══════════════════════════
   *
   * BỆNH. Collection xếp "Most relevant" thì máy chủ có lúc trả các trang CHỒNG lên
   * nhau, và bản trả về đổi theo từng lượt: đo LIVE 25/9, /collections/filipino 75 ô
   * mà chỉ 50–62 handle khác nhau (có phiên trang 2 là bản chép y trang 1), japanese
   * 237 ô / 174–191 handle. Trong nội bộ MỘT trang thì không bao giờ trùng (17/17
   * trang), nên lưới máy chủ luôn sạch — chính tệp này mới đẻ ra thẻ lặp: nối thẳng
   * `cachedAll.push(...r.c)` rồi renderPage() cắt `inStock.concat(oos)` theo từng 24
   * ô, nên hai bản của cùng một SP vốn ở hai trang khác nhau bị kéo vào CÙNG một
   * lưới (đo trên file LIVE: japanese trang 4 = 6/24 ô lặp, filipino có lượt trang
   * 2 = 10/24). inStockCount() còn đếm cả bản lặp ⇒ haveEnoughFor() báo "đủ" sớm.
   *
   * LUẬT. Giữ LẦN GẶP ĐẦU của mỗi handle — trang trước đứng trước, nên thứ tự bộ
   * sưu tập không đổi. Thẻ có handle RỖNG thì luôn giữ: rỗng là layHandle() không
   * đọc được markup, gộp chúng làm một là nuốt mất hàng thật.
   *
   * 🪤 KHÔNG ĐỤNG `cachedPageSize`: nó vẫn đo trên độ dài THÔ của trang máy chủ (xem
   *    fetchRange). Lọc r.c trước dòng đó là thu nhỏ cỡ trang, cắt sai nhịp với
   *    thanh phân trang.
   * 🪤 KHỬ TRÙNG XONG THÌ TRANG CUỐI CÓ THỂ RỖNG (ít SP duy nhất hơn số trang máy
   *    chủ khai). Chốt ở bindPagination() trả cú bấm đó cho trình duyệt — thiếu chốt
   *    là nút số trang CHẾT. Hai chỗ phải đi cùng nhau.
   * 🪤 VÁ NÀY KHÔNG GỌI VỀ ĐƯỢC món mà máy chủ đánh rơi khỏi MỌI trang (filipino:
   *    13–25/75). Gốc là kiểu sắp "Most relevant" của collection — việc dữ liệu.
   *
   * Không cần ở gieoTuLuoi(): một trang máy chủ không trùng trong nội bộ, và thẻ gieo
   * luôn vào một cachedAll RỖNG. Dựng Set lại mỗi lượt thay vì giữ một Set sống:
   * cachedAll bị thay ở bốn nơi (gieo · bộ đệm · khoiDongLai · ensureEnoughFor), giữ thêm một bản sao
   * là thêm một thứ phải nhớ đặt lại.
   *
   * Người gác: scripts/test-danh-muc-khong-lap-the.js */
  function noiKhongTrung(the) {
    const daCo = new Set();
    for (const c of cachedAll) if (c.handle) daCo.add(c.handle);
    for (const c of the) {
      if (c.handle) {
        if (daCo.has(c.handle)) continue;
        daCo.add(c.handle);
      }
      cachedAll.push(c);
    }
  }

  /* Lấy các trang máy chủ từ `from` tới `to` (đã kẹp trong khoảng hợp lệ) và nối
   * vào cachedAll. Trả về false nghĩa là BỘ ĐÃ THỦNG — đừng dùng để sắp xếp.
   *
   * Vì sao phải có đường thủng: renderPage() cắt trang từ chính bộ này. Thiếu một
   * trang giữa chừng thì 24 sản phẩm biến mất khỏi collection — không phải xếp sai
   * chỗ, mà BIẾN MẤT: không nằm ở trang nào cả. Rồi bộ đệm ướp cái bộ thủng đó lại
   * 5 phút, nên khách bấm lại cũng vẫn thiếu đúng 24 món, không một dòng báo lỗi.
   *
   * Bản cũ để lọt vì `fetch` hỏng và `trang rỗng` cùng trả về []: vòng lặp chỉ hỏi
   * `cards.length` nên trang hỏng bị lặng lẽ bỏ qua rồi các trang sau vẫn dồn vào.
   */
  async function fetchRange(from, to) {
    const luotCuaToi = luot;
    const known = serverTotalPages();
    const results = await Promise.all(
      Array.from({ length: to - from + 1 }, (_, i) => from + i).map((p) =>
        fetchPage(p).then((c) => ({ p, c })).catch(() => ({ p, c: null }))
      )
    );
    /* 5/9/2026 (vòng 42) — LƯỚI CÓ THỂ ĐÃ BỊ THAY TRONG LÚC CHỜ MẠNG.
       Lô này được gọi cho một trạng thái lọc; khách tick ô lọc giữa chừng là
       khoiDongLai() đã đổi CACHE_KEY và dựng bộ dữ liệu mới. Dồn kết quả cũ vào bộ
       mới là trộn hàng chưa lọc vào hàng đã lọc rồi ướp dưới đúng cái tên đã lọc —
       im lặng tuyệt đối. Trả false = "đừng dùng lô này", đúng đường thủng có sẵn. */
    if (luotCuaToi !== luot) return false;
    results.sort((a, b) => a.p - b.p);
    for (const r of results) {
      // LIỀN MẠCH TUYỆT ĐỐI. Nhận trang 3 khi trang 2 hỏng là tự tay đục thủng bộ
      // dữ liệu rồi lại ghi pagesFetched = 3 như thể không có gì xảy ra — 24 món
      // của trang 2 biến mất, mà haveEnoughFor() vẫn bảo "đủ rồi, dựng đi".
      if (r.p !== pagesFetched + 1) break;
      if (r.c === null || !r.c.length) {
        // Trang nằm TRONG khoảng máy chủ khai báo mà hỏng/rỗng ⇒ bộ thủng thật.
        if (known && r.p <= known) return false;
        // Đường dò (không biết tổng số trang) KHÔNG phân biệt được "trang hỏng"
        // với "đã quá trang cuối" — đúng thứ Shopify vẫn trả 404. Coi là hết.
        complete = true;
        break;
      }
      // Cỡ trang đo trên độ dài THÔ của trang máy chủ, TRƯỚC khi khử trùng: đó là
      // nhịp `paginate` của Liquid, và thanh phân trang của máy chủ đếm theo nhịp ấy.
      if (r.c.length > cachedPageSize) cachedPageSize = r.c.length;
      noiKhongTrung(r.c);
      pagesFetched = r.p;
    }
    if (known && pagesFetched >= known) complete = true;
    return true;
  }

  /* Lấy thêm cho tới khi dựng được `pageNum`, hoặc hết collection.
   * Lô đầu 2 trang: với tỉ lệ hết hàng thực tế (~40%) thì 2 trang đầu gần như luôn
   * đủ 24 SP còn hàng cho trang 1 — một vòng mạng thay vì 17. Lô sau to hơn vì lúc
   * đó đã biết là collection này nhiều hàng hết. */
  async function ensureEnoughFor(pageNum) {
    const FIRST_BATCH = 2;
    const NEXT_BATCH = 4;
    const luotCuaToi = luot;
    if (!cachedAll) cachedAll = [];
    // 14/9/2026 (vòng 48) — "đã đi mạng chưa", KHÔNG phải "đã có trang nào chưa":
    // thẻ gieo từ lưới máy chủ không tốn một lượt mạng nào nên lô mạng đầu tiên vẫn
    // phải là lô NHỎ. Xem chú thích ở chỗ khai `daGieoTuDom`.
    let batch = (pagesFetched && !daGieoTuDom) ? NEXT_BATCH : FIRST_BATCH;
    while (!complete && !haveEnoughFor(pageNum)) {
      const known = serverTotalPages();
      let from = pagesFetched + 1;
      let to = from + batch - 1;
      if (known) to = Math.min(to, known);
      if (to < from) { complete = true; break; }
      const before = pagesFetched;
      const ok = await fetchRange(from, to);
      daGieoTuDom = false;   // từ đây trở đi đã có lô mạng, cỡ lô về đúng luật cũ
      // Lưới bị thay giữa vòng lặp: bộ dữ liệu dưới chân đã là bộ khác, dừng ngay.
      if (luotCuaToi !== luot) return false;
      if (!ok) return false;
      // Chốt chặn vòng lặp vô tận. Trên đường dò (không biết tổng số trang), một
      // lô không tiến được trang nào mà cũng không đặt cờ hết thì vòng này gọi lại
      // đúng dải cũ mãi mãi — nện máy chủ cho tới khi khách đóng tab.
      if (pagesFetched === before && !complete) { complete = true; break; }
      batch = NEXT_BATCH;
    }
    return true;
  }

  /* Gợi ý ưu tiên tải ảnh, đặt LẠI sau khi sắp xếp.
   *
   * Server đã đánh dấu thẻ đầu trang bằng loading="eager" + fetchpriority="high"
   * (xem snippets/product-card.liquid). Nhưng script này gom thẻ từ NHIỀU trang rồi
   * sắp xếp lại, nên thẻ nằm ở vị trí số 1 sau khi sắp xếp thường là thẻ vốn được
   * render ở giữa trang 1 — hoặc từ trang 2, 3 — và mang loading="lazy".
   * Đo thật 12/8 trên collection Vietnamese: server phát thẻ đầu kèm eager +
   * fetchpriority, nhưng sau khi script này chạy thì thẻ đầu trong DOM lại là lazy,
   * và không ảnh nào trên trang còn fetchpriority. Trang tìm kiếm không dùng script
   * này nên vẫn đúng — đó chính là chỗ khác nhau giữa hai trang.
   *
   * Sửa trên CHUỖI HTML trước khi chèn, không phải setAttribute sau khi chèn: làm
   * sau thì trình duyệt đã quyết định xong thứ tự tải, đặt lại chỉ vớt vát được
   * phần đuôi. Chỉ đụng thẻ <img> ĐẦU TIÊN của mỗi thẻ sản phẩm — ảnh variant phía
   * sau nằm trong slider ẩn, phải giữ lazy.
   */
  /* 🔴 24/10/2026 (B2 vòng 2) — phép gợi ý này (4 ảnh đầu eager, ảnh đầu fetchpriority=high, còn lại
     lazy) nay là CHUNG.goiYLcp của khối inline: khối VẼ của section vẽ lát cắt đã sắp lúc phân tích HTML
     bằng đúng phép đó, và renderPage() dưới đây gọi CHUNG.ve() — cùng một hàm vẽ cho cả hai. */

  /* Lát cắt ĐÃ SẮP của trang `pageNum` — một chỗ, renderPage() và cổng theo vị trí
     (duocDeLuoiMayChu) cùng đọc, để "ô nào sẽ đổi" không có hai câu trả lời. */
  /* 🔴 24/10/2026 (B2) — phép cắt nay sống ở khối inline (CHUNG.lat): khối VẼ của section cần đúng lát
     cắt này lúc phân tích HTML để vẽ bản đã sắp. Một hàm, hai người gọi. */
  function latTrang(pageNum) {
    return CHUNG.lat(cachedAll, pageSize(), pageNum);
  }

  function renderPage(pageNum) {
    if (!haveEnoughFor(pageNum)) return false;
    const wanted = latTrang(pageNum);
    if (!wanted.length) return false;
    /* ══ 🔴 14/9/2026 (vòng 48) — LƯỚI ĐÃ ĐÚNG RỒI THÌ ĐỪNG GHI ĐÈ CHO KHÔNG ══════
     * Sau khi gieoTuLuoi() chạy, trường hợp phổ biến nhất là thứ tự sắp lại TRÙNG
     * KHÍT thứ tự máy chủ đã dựng (collection nào trang 1 không có món hết hàng thì
     * trùng 24/24, và lúc đó haveEnoughFor(1) đúng ngay nên không đi mạng lần nào).
     * Ghi `grid.innerHTML` ở đó là vứt 24 phần tử đang sống đi để dựng lại 24 phần
     * tử y hệt: mất trạng thái stepper/dịch đang có, chạy lại cả một vòng
     * `aef:cards-injected` (kéo theo một lượt /cart.js của card-stepper), và làm
     * trình duyệt quyết định lại thứ tự tải ảnh. So mảng handle rồi bỏ hẳn lượt ghi.
     *
     * 🪤 KHÔNG ĐỤNG `aef-grid-restaged` Ở NHÁNH NÀY: lớp đó là `animation: none`
     * (aef-product-card.css:1710). Không thay thẻ mà bật nó lên là CẮT NGANG hiệu
     * ứng aefTileIn đang chạy trên chính lưới máy chủ — nháy một cái vì không có lý
     * do gì. Vẫn hạ `firstPaint`: lượt vẽ SAU (khách bấm số trang) là nội dung MỚI
     * nên đúng là phải được nhả theo nhóm.
     * 🪤 KHÔNG BẮN `aef:cards-injected`: không có thẻ nào mới vào DOM thì không có
     * ai phải dịch lại hay dựng lại stepper. Bắn ra là đẻ việc từ hư không. */
    /* `every` trên mảng toàn chuỗi RỖNG cũng trả true — mà handle rỗng là dấu hiệu
       layHandle() không còn đọc được markup. Lúc đó "trùng khít" là kết luận rác, và
       bỏ lượt ghi sẽ giết cả bộ sắp xếp trong im lặng. Đòi handle thật ở cả hai mảng.
       2026-08-17 (Phase 6) — CẮT HIỆU ỨNG NHẢ THEO NHÓM Ở ĐÚNG LƯỢT NÀY.
     * Dòng dưới thay TOÀN BỘ thẻ bằng phần tử MỚI ⇒ luật `aefTileIn` trong
     * aef-product-card.css chạy LẠI. Lượt vẽ đầu tiên chỉ là sắp lại thứ tự
     * thứ khách ĐANG NHÌN (hàng hết xuống cuối) nên phải liền mạch tuyệt đối —
     * cho chạy hiệu ứng ở đây là một cú nháy giữa chừng, tệ hơn hẳn thứ nó thay.
     * Các lượt sau (bấm phân trang, popstate) là nội dung MỚI, gỡ cờ ra cho
     * hiệu ứng chạy vì lúc đó nó đúng việc: che khoảng chờ mạng.
     * 🔴 24/10/2026 (B2 vòng 2) — so-trùng + gắn cờ aef-grid-restaged TRƯỚC khi ghi + ghi innerHTML (kèm
     * gợi ý LCP) + bắn aef:cards-injected nay là MỘT hàm CHUNG.ve() của khối inline, vì khối VẼ của section
     * vẽ đúng lát này lúc phân tích HTML. Mọi luật trong khối chú thích này áp cho hàm đó. */
    CHUNG.ve(grid, wanted, firstPaint);
    firstPaint = false;
    return true;
    /* 2026-08-16 — BÁO CHO CẦU i18n + STEPPER (nay nằm trong CHUNG.ve).
     * Thẻ vừa nhét vào là HTML MỚI TINH từ máy chủ, tức tiếng Anh: Shopify không
     * biết gì về cầu data-i18n của mình. Trước dòng này, khách đang xem tiếng Việt
     * mở BẤT KỲ trang collection nào cũng thấy lưới hiện đúng tiếng Việt trong tích
     * tắc rồi sau một vòng mạng lật hết sang tiếng Anh ("Thêm vào giỏ" → "Add to
     * cart", "Mua tối thiểu" → "Min order:") và nằm y vậy tới khi tải lại trang.
     * Cùng lúc, card-stepper.js:436 cũng nghe sự kiện này để dựng lại số lượng theo
     * giỏ cho thẻ mới — không có nó thì món đang có trong giỏ hiện lại thành nút "+".
     * Đúng một sự kiện, hai người nghe có sẵn: không đẻ thêm người ghi nào. */
  }

  /* Tổng số trang KHÔNG đổi vì sắp xếp lại: vẫn từng ấy sản phẩm. Nên lấy con số
   * máy chủ khai báo — đúng ngay cả khi mới lấy 2/18 trang. Bản cũ tính bằng
   * ceil(số thẻ đã lấy / cỡ trang), chỉ đúng khi đã lấy hết. */
  function totalPages() {
    const known = serverTotalPages();
    if (known) return known;
    if (!cachedAll || !cachedAll.length) return 1;
    return Math.ceil(cachedAll.length / pageSize());
  }

  function pageUrl(p) {
    const u = new URL(location.href);
    if (p <= 1) u.searchParams.delete('page');
    else u.searchParams.set('page', String(p));
    return u.pathname + u.search;
  }

  /* Build Shopify-style pagination parts: first ± 1, current ± 1, last ± 1, ellipsis between */
  function buildParts(current, total) {
    const set = new Set([1, 2, current - 1, current, current + 1, total - 1, total]);
    const list = Array.from(set).filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
    const out = [];
    let prev = 0;
    for (const p of list) {
      if (p - prev > 1) out.push({ ellipsis: true });
      out.push({ page: p });
      prev = p;
    }
    return out;
  }

  /* 🔴 25/9/2026 (vòng 53, i18n#7) — NHÃN NGHE ĐƯỢC PHẢI ĐỔI THEO NÚT VI.
   * Thanh này có HAI người vẽ: snippets/pagination.liquid (lúc tải trang) và hàm
   * này (mỗi cú bấm số trang, mỗi nút Back). Bản cũ gõ cứng "Previous"/"Page N"/
   * "Next", không móc ⇒ khách VI bấm sang trang 2 là máy đọc quay về tiếng Anh, lại
   * còn khác chữ Liquid. Nay cùng khoá + cùng chữ EN với Liquid (a11y.page_prev ·
   * a11y.page_n + data-i18n-n · a11y.page_next), và tự gọi bộ dịch SAU khi ghi:
   * lượt dịch của `aef:cards-injected` mà renderPage() bắn đã chạy TRƯỚC dòng ghi
   * innerHTML (người nghe của widget chạy đồng bộ) nên không với tới thanh mới.
   * Gác: scripts/test-nhan-nghe-duoc-ngoai-gio-doi-tieng.js (mệnh đề P). */
  function renderPagination(current, total) {
    const ul = document.querySelector('.pagination-wrapper .pagination__list');
    if (!ul) return;
    if (total <= 1) { ul.innerHTML = ''; return; }
    let html = '';
    if (current > 1) {
      html += '<li><a href="' + pageUrl(current - 1) + '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Previous page" data-i18n-aria-label="a11y.page_prev"><i class="fa fa-angle-left"></i></a></li>';
    }
    const parts = buildParts(current, total);
    for (const p of parts) {
      if (p.ellipsis) {
        html += '<li><span class="pagination__item">…</span></li>';
      } else if (p.page === current) {
        html += '<li><span class="pagination__item pagination__item--current" aria-current="page" aria-label="Page ' + p.page + '" data-i18n-aria-label="a11y.page_n" data-i18n-n="' + p.page + '">' + p.page + '</span></li>';
      } else {
        html += '<li><a href="' + pageUrl(p.page) + '" class="pagination__item link" aria-label="Page ' + p.page + '" data-i18n-aria-label="a11y.page_n" data-i18n-n="' + p.page + '">' + p.page + '</a></li>';
      }
    }
    if (current < total) {
      html += '<li><a href="' + pageUrl(current + 1) + '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Next page" data-i18n-aria-label="a11y.page_next"><i class="fa fa-angle-right"></i></a></li>';
    }
    ul.innerHTML = html;
    if (typeof window.applyTranslations === 'function') { try { window.applyTranslations(); } catch (e) {} }
  }

  function bindPagination() {
    const pageLinks = document.querySelectorAll('.pagination-wrapper a.pagination__item');
    pageLinks.forEach((a) => {
      if (a.dataset.aeBound) return;
      a.dataset.aeBound = '1';
      a.addEventListener('click', function (e) {
        const href = a.getAttribute('href') || '';
        const m = href.match(/[?&]page=(\d+)/);
        const target = m ? parseInt(m[1], 10) : 1;
        if (!target || target < 1 || target > totalPages()) return;
        /* 🔴 24/10/2026 (B2 vòng 2, N2 người soi soi-luoi-b2) — TRANG NÀY ĐANG BÀY BẢN MÁY CHỦ ⇒ ĐỪNG CƯỚP.
           Bày trang N theo phép chia của máy chủ rồi cắt N+1 từ danh sách ĐÃ SẮP là hai phép chia lẫn
           nhau: món còn hàng mà bản đã sắp kéo lên trang N (máy chủ để ở N+1) không bao giờ hiện. jsdom:
           giữ trang 1 máy chủ rồi bấm "2" ⇒ hụt u04. Trả cú bấm cho trình duyệt VÀ để dấu cho đúng lượt
           tải trang đích: nó cũng giữ bản máy chủ (xem docDauGiuMayChu) — không có dấu thì lượt VÀO ở đầu
           trang được sắp (luật vòng 48/B1) và hụt món y như cũ, chỉ chậm hơn một lượt tải.
           🔴 30/10/2026 (người soi 0bf6975f) — CHỈ ĐỂ DẤU KHI ĐI TỚI. "Hụt món" chỉ sinh ra khi đi TỚI: món bị
           đẩy qua ranh trang nằm ở trang SAU, đi lùi không nhảy qua món nào. Bản trước để dấu cả cú lùi ⇒ vào
           thẳng ?page=2 (đang giữ) rồi bấm "1" thì trang 1 giữ bản máy chủ, mất sắp xếp oan. Cú lùi vẫn trả cho
           trình duyệt, chỉ là không dấu: lượt tải trang đích được sắp như một lượt vào thường. */
        if (giuMayChu) { if (target > currentPage) datDauGiuMayChu(target); return; }
        // Chỉ cướp cú bấm khi dựng được NGAY. Chưa đủ dữ liệu (bộ nạp nền chưa
        // xong, hoặc có trang lỗi) thì để trình duyệt đi đường thường — thà một
        // lượt tải trang còn hơn cướp cú bấm rồi treo chờ mạng.
        if (!haveEnoughFor(target)) return;
        /* 25/9/2026 (vòng 53) — lát cắt của trang đích RỖNG thì cũng trả về. Khử
           trùng (noiKhongTrung) làm số thẻ duy nhất có thể ít hơn số trang máy chủ
           khai, nên trang cuối cắt ra mảng rỗng; renderPage() trả false SAU khi cú
           bấm đã bị preventDefault ⇒ nút chết. Để máy chủ dựng trang đó. */
        if ((target - 1) * pageSize() >= cachedAll.length) return;
        /* 15/9/2026 (vòng 49) — cùng một luật "không cướp cú bấm nếu không trả được
           một trang ĐÚNG": thiếu dữ liệu thì trả về (dòng trên), mà thiếu phần NGOÀI
           lưới của trang 1 thì cũng trả về. Khối chú thích ở duPhanNgoaiLuoi() nói rõ
           vì sao chốt này phải đứng TRƯỚC preventDefault. */
        if (!duPhanNgoaiLuoi(target)) return;
        e.preventDefault();
        navigateTo(target, true);
      });
    });
  }

  /* Khối nội dung SEO (giới thiệu · FAQ · danh mục liên quan) chỉ thuộc TRANG 1 —
     Liquid đã chặn bằng `current_page == 1`. Nhưng phân trang ở đây chạy phía client
     và ĐẨY `?page=N` vào URL mà KHÔNG tải lại, nên không tự ẩn thì cùng một URL cho
     hai kết quả khác nhau: bấm sang trang 2 vẫn thấy FAQ, mà nhấn F5 thì mất.
     Google không bị ảnh hưởng (trình thu thập luôn nhận bản máy chủ) — đây là chuyện
     nhất quán với người dùng.
     Dùng `style.display` chứ không dùng thuộc tính `hidden`: `hidden` dễ bị một luật
     `display` nào đó trong bộ CSS đè mất, mà bộ này có cả bootstrap.

     🔴 5/9/2026 (vòng 42) — HÀM NÀY CHỈ CÓ ĐƯỜNG TẮT, KHÔNG AI BẤM LẠI.
     Bốn khối nằm NGOÀI #ProductGridContainer (sections/main-collection-product-grid
     .liquid:37 và :264 — cố ý, xem chú thích ở đó), nên khi facets.js thay ruột
     container thì KHÔNG AI đặt lại chúng. Đường khách đi thật: bấm số 2 (hàm này ghi
     `display:none` vào từng khối) → tick một ô lọc → facets đẩy URL VỀ TRANG 1 và
     dựng lại lưới, mà bốn khối vẫn nằm đó với `display:none` cứng trên thuộc tính
     style. URL nói trang 1, lưới là trang 1, còn giới thiệu · FAQ · danh mục liên
     quan · công thức thì biến mất tới khi khách F5. Nay khoiDongLai() gọi lại hàm này
     với số trang ĐỌC TỪ URL MỚI, nên lượt lọc nào cũng trả bốn khối về đúng trạng thái.

     🔴 Cùng ngày — `.aef-rcp` THIẾU TRONG DANH SÁCH. Dải "Cook with these ingredients"
     (snippets/aef-related-recipes.liquid:58) cũng chỉ được máy chủ dựng ở trang 1
     (section:294, trong cùng khối `current_page == 1`), nhưng bộ chọn cũ không nhắc
     tới nó ⇒ bấm sang trang 2 bằng phân trang tức thì thì ba khối kia biến đi còn dải
     công thức ở lại — đúng cái nội dung nhân bản mà hàm này sinh ra để chặn. */
  var KHOI_SEO_SEL = '.aef-seo-intro, .aef-faq, .aef-related, .aef-rcp';

  function toggleSeoBlocks(pageNum) {
    const els = document.querySelectorAll(KHOI_SEO_SEL);
    for (let i = 0; i < els.length; i++) els[i].style.display = pageNum <= 1 ? '' : 'none';
  }

  /* ══ 🔴 15/9/2026 (vòng 49) — TRANG 1 KHÔNG CHỈ LÀ CÁI LƯỚI ═══════════════════
   *
   * BỆNH. toggleSeoBlocks() chỉ đặt `style.display` cho phần tử ĐANG CÓ; không có
   * gì trong tài liệu thì vòng `for` chạy 0 lượt, im lặng tuyệt đối. Khách vào thẳng
   * `?page=2` (từ Google, từ bookmark, hay sau một cú rơi về tải trang thật khi
   * haveEnoughFor trượt) rồi bấm nút "1": phân trang tức thì cướp cú bấm, đẩy URL về
   * `/collections/x` — đúng URL chuẩn của trang 1 — mà dưới lưới KHÔNG còn khối giới
   * thiệu, không FAQ, không dải danh mục liên quan, không dải công thức. Nhấn F5 thì
   * chúng hiện lại. Tiệm mất cả nội dung lẫn đám link nội bộ ở đúng trang đích quan
   * trọng nhất của danh mục, mà không có một dấu hiệu nào.
   *
   * VÌ SAO TRẢ CÚ BẤM CHO TRÌNH DUYỆT, CHỨ KHÔNG ĐI LẤY BỐN KHỐI VỀ. Dựng lại chúng
   * phía client nghĩa là thêm một người ghi thứ hai cho cùng bốn khối đó (một người
   * là Liquid, một người là tệp này) — đúng họ lỗi "một khái niệm, hai nguồn dữ liệu".
   * Trả cú bấm về thì máy chủ dựng trang 1 ĐỦ CẢ: lưới, thanh phân trang, ô lọc đang
   * tick, dòng đếm sản phẩm và cả bốn khối. Giá phải trả là đúng MỘT lượt tải trang,
   * ở đúng một cú bấm hiếm.
   *
   * 🪤 PHẢI CHẶN Ở bindPagination(), KHÔNG PHẢI TRONG navigateTo(). Người nghe cú bấm
   * gọi `e.preventDefault()` TRƯỚC khi gọi navigateTo(), nên `return` sớm trong
   * navigateTo là cú bấm đã bị nuốt rồi mà không ai đi đâu cả: nút phân trang thành
   * nút CHẾT — tệ hơn hẳn cái bệnh đang vá. Quyết định phải nằm trước preventDefault.
   *
   * 🪤 HỎI CẢ HAI VẾ, KHÔNG CHỈ HỎI "BỐN KHỐI CÓ MẶT KHÔNG". Danh mục chưa đổ nội
   * dung SEO thì máy chủ dựng trang 1 cũng KHÔNG có khối nào — hỏi mỗi DOM là mọi
   * cú bấm về trang 1 của những danh mục đó đều rơi về tải trang thật cho không.
   * Nên: tài liệu này vốn là trang 1 (⇒ phần ngoài lưới máy chủ gửi thế nào thì đang
   * nằm đó thế ấy) HOẶC bốn khối có mặt thật. Sai cả hai mới trả cú bấm về. */
  function duPhanNgoaiLuoi(pageNum) {
    if (pageNum > 1) return true;              // trang ≥2 vốn không có phần này
    if (taiTrangGocLaMot) return true;
    return !!document.querySelector(KHOI_SEO_SEL);
  }

  function navigateTo(pageNum, push) {
    if (!renderPage(pageNum)) return;
    currentPage = pageNum;
    toggleSeoBlocks(pageNum);
    if (push) {
      const u = new URL(location.href);
      if (pageNum <= 1) u.searchParams.delete('page');
      else u.searchParams.set('page', String(pageNum));
      history.pushState({ page: pageNum }, '', u.toString());
    }
    renderPagination(currentPage, totalPages());
    bindPagination();
    const top = grid.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    /* 🔴 15/9/2026 (vòng 49) — ĐẨY TRẦN NẠP TRƯỚC THEO CHÂN KHÁCH.
     * Trần của prefetchRest là `currentPage + TRANG_DEM_TRUOC`, mà TRƯỚC dòng này
     * prefetchRest chỉ được gọi từ init() — tức đúng MỘT lần cho mỗi lượt tải trang.
     * Phân trang tức thì không tải lại trang, cũng không gọi init(): renderPage chỉ
     * ghi `grid.innerHTML` nên danh tính node không đổi, và khoiDongLai() rút lui ngay
     * ở `moi === grid`. Nên trần đứng yên ở chỗ khách VÀO, không phải chỗ khách ĐANG
     * ĐỨNG. Đo trên khuôn 20 trang (scripts/test-tran-nap-truoc-truot-theo-khach.js):
     * bấm 2→3→4→5 tức thì, tới 6 là haveEnoughFor trượt ⇒ rơi về tải trang thật,
     * kéo theo nguyên cú thay lưới dưới tay khách. Gọi ở đây thì trần trượt đúng như
     * khối chú thích của TRANG_DEM_TRUOC vẫn mô tả.
     *
     * 🪤 KHÔNG SỢ CHỒNG LƯỢT: prefetchRest tự đọc `currentPage` lúc CHẠY (trong `run`,
     * sau requestIdleCallback) chứ không chụp lúc gọi, và cả nó lẫn fetchRange đều
     * kiểm `luot` ở hai đầu. Hai vòng ensureEnoughFor chạy chồng nhau cũng không đục
     * thủng bộ dữ liệu: fetchRange bỏ mọi lô không nối liền `pagesFetched + 1`.
     *
     * 🪤 KHÔNG THAY THẾ NGAN_DOI_MS: chốt "còn kịp đè" canh lượt ghi đè LẠNH lúc tải
     * trang; dòng này chỉ làm cú rơi về tải trang thật hiếm đi. Hai việc khác nhau.
     *
     * 🪤 `complete` RỒI THÌ ĐỪNG GỌI: nhánh đầu của prefetchRest là
     * `if (complete) { saveCache(); return; }`. Cả bộ sưu tập đã nằm trong tay thì
     * không còn trần nào để trượt, mà gọi vào đó là ƯỚP LẠI toàn bộ mảng thẻ vào
     * sessionStorage — một cú JSON.stringify vài trăm KB CHẶN LUỒNG CHÍNH — ở MỌI cú
     * bấm số trang, cho không. Bộ đệm đã được ướp từ cuối init() rồi. */
    if (!complete) prefetchRest();
  }

  /* ══ 🔴 5/9/2026 (vòng 42) — BÁM LẠI VÀO LƯỚI ĐANG SỐNG SAU MỖI LƯỢT LỌC ══════
   *
   * BẢN CŨ HỎNG THẾ NÀO. `#product-grid` được chụp đúng một lần lúc tải trang. Tick
   * một ô lọc (hoặc đổi ô "Sort by") thì assets/facets.js:272 chạy
   * `target.innerHTML = parsed.innerHTML` trên #ProductGridContainer — cái node mình
   * đang cầm rời khỏi tài liệu (đo được: `grid.isConnected` true → FALSE). Từ giây đó:
   *   · renderPage() ghi thẻ vào một node MỒ CÔI, khách không thấy gì;
   *   · nhưng renderPagination()/bindPagination() lại hỏi `document`, tức chúng cắm
   *     vào thanh phân trang MỚI đang sống.
   * Hai nửa của cùng một việc quay ra hai cái DOM khác nhau. Hậu quả nặng nhất là cú
   * NÚT LÙI: khách xem trang 2 (mình đã pushState `{page:2}`) → lọc → bấm Back. Mục
   * lịch sử đó là của mình, mà facets.js cố ý bỏ qua state không có khoá `searchParams`
   * (facets.js:37, bản vá chống URL "&undefined" — đừng đảo lại), nên KHÔNG AI dựng
   * lại lưới. Đo trên chromium: 3/3 cú bấm số trang sau đó đổi URL và đổi ô sáng mà
   * thẻ đầu lưới ĐỨNG NGUYÊN, không một lượt tải trang nào cứu — thanh phân trang
   * thành nút chết cho tới khi khách F5.
   *
   * VÌ SAO NGHE `aef:cards-injected` CHỨ KHÔNG DỰNG NGƯỜI THEO DÕI RIÊNG. Sự kiện này
   * là HỢP ĐỒNG SẴN CÓ của theme cho đúng việc "vừa nhét thẻ mới vào DOM"; chính
   * facets.js:286 phát nó ra sau mỗi lần thay lưới, và ae-delivery-widget + card-stepper
   * đã nghe từ trước. Thêm một MutationObserver là đẻ người-ghi-thứ-hai cho cùng một
   * sự thật.
   *
   * 🪤 BẪY 1 — PHẢI HOÃN MỘT NHỊP. Đường "đã có sẵn trong bộ nhớ" của facets
   * (renderSectionFromCache) chạy ĐỒNG BỘ, và `updateURLHash()` nằm SAU vòng lặp
   * sections (facets.js:194) ⇒ lúc sự kiện nổ, `location` vẫn là URL CŨ. Đọc khoá và
   * số trang ngay tại đó là đọc nhầm trạng thái. `setTimeout(…, 0)` cho URL chốt xong.
   *
   * 🪤 BẪY 2 — CHÍNH MÌNH CŨNG PHÁT SỰ KIỆN NÀY (renderPage). Không có gì để chặn vòng
   * lặp bằng cờ: câu hỏi đúng là "cái lưới đang sống có còn là cái mình đang cầm
   * không". renderPage chỉ ghi innerHTML nên danh tính node KHÔNG đổi ⇒ tự nhiên không
   * có vòng lặp, mà cũng không cần biết ai vừa phát.
   *
   * 🪤 BẪY 3 — GIỮ DỮ LIỆU KHI KHOÁ KHÔNG ĐỔI. Facets có thể dựng lại lưới cho ĐÚNG
   * URL đang xem; ném bộ đệm đi lúc đó là bắt khách chờ lại 17 trang không vì gì. */
  function khoiDongLai() {
    const moi = document.getElementById('product-grid');
    if (!moi || moi === grid) return false;   // không ai thay lưới ⇒ không có việc gì
    luot++;                                   // mọi lô đang bay của bộ cũ hết hiệu lực
    grid = moi;
    sectionId = grid.dataset.id || 'product-grid';
    currentPage = trangTuUrl();
    const khoaMoi = tinhCacheKey();
    if (khoaMoi !== CACHE_KEY) {
      CACHE_KEY = khoaMoi;
      cachedAll = null;
      cachedPageSize = 0;
      pagesFetched = 0;
      complete = false;
      cacheT = 0;
      daGieoTuDom = false;   // 14/9/2026 (vòng 48) — bộ dữ liệu về 0 thì cờ về theo
    }
    firstPaint = true;
    /* 🔴 14/9/2026 (vòng 48) — lưới này do facets.js vừa dựng, khách chưa kịp chạm
       vào nó: đồng hồ "còn kịp đè" phải chạy lại từ đầu. Không đặt lại thì mọi lượt
       lọc sau giây thứ 1,2 của phiên đều rơi vào nhánh giữ-bản-máy-chủ ⇒ sắp xếp
       chết hẳn trên đường LỌC, đúng thứ Boss đòi phải chạy "regardless of filter". */
    mocDoi = Date.now();
    daChamLuoi = false;
    hoiViTri = false;   // 23/10/2026 (LU2) — đường lọc: KHÔNG hỏi vị trí, xem khachDaThayODoi()
    toggleSeoBlocks(currentPage);             // lượt lọc luôn về trang 1 ⇒ trả 4 khối lại
    init().catch(reveal);
    return true;
  }
  document.addEventListener('aef:cards-injected', function () { setTimeout(khoiDongLai, 0); });

  window.addEventListener('popstate', function (e) {
    const st = e && e.state;
    const khoaUrl = tinhCacheKey();
    if (khoaUrl !== CACHE_KEY) {
      /* 🔴 5/9/2026 (vòng 42) — MỤC LỊCH SỬ NÀY THUỘC MỘT TRẠNG THÁI LỌC KHÁC.
       * Bộ đệm đang cầm là của trạng thái khác hẳn ⇒ dựng từ nó ra là bày hàng ĐÃ LỌC
       * dưới một URL CHƯA LỌC. Bản cũ làm đúng chuyện đó, và vì lưới nó ghi vào là node
       * mồ côi nên khách thậm chí không thấy gì đổi — chỉ thấy nút phân trang chết.
       * Ai dựng lại được? facets.js, NHƯNG chỉ với mục lịch sử nó nhận (state null hoặc
       * có khoá `searchParams`) và chỉ khi form lọc còn trên trang. Đúng chỗ này nó
       * KHÔNG nhận (state của mình là `{page:N}`) — nên trả cú Back lại cho trình duyệt
       * bằng một lượt tải trang thật. Máy chủ dựng lại đủ cả: lưới, thanh phân trang,
       * ô lọc đang tick, dòng đếm sản phẩm và bốn khối SEO. Nhẹ tay hơn thì phải sửa
       * facets.js (đồng bộ luôn phần ngoài container) — ngoài phạm vi file này. */
      if (document.querySelector('facet-filters-form') &&
          (!st || Object.prototype.hasOwnProperty.call(st, 'searchParams'))) return;
      location.reload();
      return;
    }
    const target = trangTuUrl();
    if (renderPage(target)) {
      currentPage = target;
      giuMayChu = false;   // B2 vòng 2: lưới vừa vẽ là lát cắt đã sắp
      toggleSeoBlocks(target); // nút Back cũng phải trả khối SEO về đúng trạng thái
      renderPagination(currentPage, totalPages());
      bindPagination();
      return;
    }
    /* Không dựng nổi trang mà URL thì đã nhảy rồi: lưới đang bày MỘT TRANG KHÁC với
       cái URL trên thanh địa chỉ. Bản cũ im lặng bỏ qua. Cướp cú bấm thì phải trả bằng
       một trang đúng — không trả được thì trả lại quyền cho trình duyệt. */
    if (target !== currentPage) location.reload();
  });

  /* Lấy nốt phần còn lại — CHẠY LÚC RẢNH, sau khi trang đã dựng xong.
   *
   * Đây là chỗ 256 KB từng nằm: bản cũ lấy cả 17 trang TRƯỚC khi dựng lưới, bắt
   * đầu ở ~1,86s — đúng lúc trình duyệt đang cần đường cho ảnh LCP. Giờ phần dựng
   * lưới chỉ cần 2 trang, phần còn lại dời xuống đây nên không tranh băng thông
   * với ảnh nữa; đổi lại vẫn giữ được phân trang tức thì như cũ. */
  /* 🔴 6/9/2026 (vòng 43) — TRẦN CHO LƯỢT NẠP NỀN.
   *
   * Trước bản vá, hàm này gọi `ensureEnoughFor(totalPages())`, tức KÉO VỀ CẢ
   * COLLECTION. Đo trên LIVE, Pixel 7, mở /collections/snacks rồi NGỒI YÊN không
   * bấm gì: 20/20 trang được kéo về trong 5 giây, không cần khách yêu cầu. Trên
   * /collections/all thì `data-total-pages` là 110 ⇒ 110 lượt.
   *
   * Cái đó đắt ở ba chỗ, và không chỗ nào hiện ra trong số đo FCP/LCP nên nó đã
   * nằm im lâu:
   *   · dữ liệu 4G của khách — mỗi trang lưới ~285 KB HTML thô;
   *   · luồng chính phải phân tích chừng ấy HTML;
   *   · 20-110 yêu cầu dồn một lúc, chính là thứ khiến Shopify trả 429 cho lượt
   *     nạp nền của CHÍNH TRANG NÀY (đã bắt được trong hồ sơ chụp: hai mục 429
   *     trên đúng URL do hàm này dựng).
   *
   * VÌ SAO CHẶN LẠI LÀ AN TOÀN: `bindPagination()` (:396) chỉ cướp cú bấm khi
   * `haveEnoughFor(target)` — không đủ dữ liệu thì nó TRẢ LẠI cú bấm cho trình
   * duyệt và khách đi đường tải trang thường, do máy chủ dựng, đúng đủ cả lưới
   * lẫn thanh phân trang. Nên trần này làm chậm đúng cú nhảy sang trang xa, chứ
   * không làm hỏng gì.
   *
   * VÌ SAO KHÔNG BỎ HẲN: mục đích của cả tệp là xếp hàng hết xuống cuối, và việc
   * đó cần nhiều thẻ hơn một trang máy chủ (khoảng 40% hết hàng). Giữ vài trang
   * đệm phía trước thì phân trang vẫn tức thì ở đúng khoảng khách hay đi.
   *
   * Con số 3: khách đi tới trang 1-4 là gần hết. Vì ~40% hết hàng nên để dựng
   * được trang 4 phía khách, hàm vẫn tự lấy khoảng 7 trang nguồn — vẫn còn xa
   * 20, và xa hẳn 110.
   *
   * 🔴 15/9/2026 (vòng 49) — CHÚ THÍCH CŨ Ở ĐÂY NÓI NGƯỢC VỚI MÃ, ĐÃ SỬA.
   * Nó viết: «Mỗi lần khách sang trang mới thì `init()` chạy lại và trần trượt theo».
   * KHÔNG ĐÚNG, và không đúng ngay từ lúc viết: phân trang tức thì không tải lại
   * trang, navigateTo() không gọi init(), còn khoiDongLai() thì rút lui ở
   * `moi === grid` (renderPage chỉ ghi innerHTML nên danh tính node không đổi) —
   * chỉ facets.js thay ruột container mới kích hoạt được init() lần nữa. Hệ quả đo
   * được trên khuôn 20 trang: trần đứng yên ở chỗ khách VÀO, nên bấm tới trang 6 là
   * rơi về tải trang thật. Nay navigateTo() gọi thẳng prefetchRest() ở cuối, và
   * `currentPage` được đọc lúc CHẠY, nên trần mới thật sự trượt theo khách.
   */
  var TRANG_DEM_TRUOC = 3;

  function prefetchRest() {
    if (complete) { saveCache(); return; }
    /* 5/9/2026 (vòng 42) — lượt nạp nền này sống lâu nhất trong cả file, nên nó cũng
       là chỗ dễ ghi đè nhất: khách tick ô lọc trong lúc nó đang lấy nốt 15 trang thì
       saveCache() sẽ ướp dữ liệu CHƯA LỌC dưới khoá ĐÃ LỌC. Kiểm số lượt ở cả hai
       đầu — trước khi chạy, và trước khi ướp. */
    const luotCuaToi = luot;
    const run = function () {
      if (luotCuaToi !== luot) return;
      /* Trần: chỉ đệm trước vài trang quanh chỗ khách đang đứng, KHÔNG kéo cả
         collection. `Math.min` giữ cho nó không đòi quá số trang thật. */
      const den = Math.min(totalPages(), currentPage + TRANG_DEM_TRUOC);
      ensureEnoughFor(den)
        .then(function (ok) { if (ok && luotCuaToi === luot) saveCache(); })
        .catch(function () {});
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 1200);
  }

  async function init() {
    const luotCuaToi = luot;
    /* ══ 🔴 25/9/2026 (vòng 53) — LƯỚI MÁY CHỦ RỖNG THÌ KHÔNG ĐI MẠNG ═════════════
     *
     * BỆNH. Vào `?page=999` (link cũ, bookmark, Google giữ trang sâu sau khi
     * collection co lại) thì máy chủ dựng NHÁNH RỖNG: `<div class="collection
     * collection--empty" id="product-grid">`, 0 thẻ, không phân trang, không
     * data-total-pages. serverTotalPages() ra 0 nên rơi vào đường DÒ, và
     * haveEnoughFor(999) đòi 999×24 thẻ còn hàng — nhiều hơn cả kho — nên vòng lặp
     * chỉ thoát khi đã kéo HẾT collection rồi dò thêm một lô. Đo trên file LIVE
     * (jsdom, fetch giả): new-arrivals-1 (110 trang) → 114 lượt ?section_id=, ~33 MB
     * HTML qua DOMParser trên luồng chính, hai lượt saveCache cỡ 29 triệu ký tự đều
     * ném QuotaExceeded. Rồi vứt hết: renderPage(999) cắt ra mảng rỗng. Lọc ra 0
     * kết quả (cùng nhánh rỗng, qua khoiDongLai) cũng tốn 2 lượt thừa.
     *
     * LUẬT. Lưới không có thẻ nào thì không có gì để sắp, không có phân trang để
     * cướp ⇒ reveal() rồi thôi. Hỏi đúng bộ chọn `.grid__item` của docLuoi() — một
     * nguồn cho khái niệm "lưới có thẻ". Nhánh có hàng luôn có ≥1 thẻ (Liquid in cả
     * hàng hết), nên chốt này không chặn nhầm được lưới thật.
     *
     * 🪤 ĐẶT TRƯỚC BỘ ĐỆM: bộ đệm cùng khoá (khoá bỏ `page`) còn hạn thì fast path sẽ
     *    renderPage() đè lên câu trả lời "0 kết quả" của máy chủ bằng thẻ cũ.
     * 🪤 ĐẶT TRONG init(), KHÔNG ĐẶT Ở ĐẦU IIFE: ở đó người nghe `aef:cards-injected`
     *    và `popstate` bên dưới sẽ không bao giờ được gắn ⇒ vào link lọc-ra-0 rồi bỏ
     *    lọc là mất luôn sắp xếp hàng-hết-xuống-cuối cho cả phiên.
     * 🪤 KHÔNG hỏi `classList.contains('collection--empty')` (facets.js khungLuoi()
     *    đã dặn): hỏi thẳng "có thẻ không" thì bền hơn tên lớp.
     *
     * Người gác: scripts/test-danh-muc-rong-khong-di-mang.js */
    if (!grid.querySelector('.grid__item')) { reveal(); return; }
    /* 🔴 24/10/2026 (B2 vòng 2, N2) — lượt tải này là cú bấm số trang mà trang TRƯỚC (đang bày bản máy
       chủ) đã trả cho trình duyệt ⇒ giữ bản máy chủ nốt, để cả chuỗi trang đi theo MỘT phép chia. */
    giuMayChu = false;
    const theoDauMayChu = docDauGiuMayChu();
    /* Fast path — bộ đệm, kể cả bộ đang dở của lượt xem trước */
    const cached = loadCache();
    if (cached && cached.cards && cached.cards.length) {
      cachedAll = cached.cards;
      cacheT = cached.t || 0;
      cachedPageSize = cached.pageSize || 0;
      pagesFetched = cached.pages || 0;
      complete = !!cached.complete;
      if (haveEnoughFor(currentPage)) {
        /* 🔴 23/10/2026 (LU2) — nhánh này là nhánh của mọi lượt TẢI LẠI khi đang
           cuộn; trước bản vá nó đè KHÔNG qua cổng nào. Xem khachDaThayODoi().
           🔴 24/10/2026 (B2 — phương án (a)) — LƯỚI ĐANG ẨN (khối inline đã ẩn nó vì
           lượt này là tải lại / Lùi có bộ đệm đủ) ⇒ khách CHƯA thấy ô nào: vẽ thẳng bản
           đã sắp, khỏi hỏi cổng — reveal() ngay dưới mới cho lưới hiện. Đây là chỗ trang
           ≥2 được sắp lại khi tải lại / Lùi (cổng vị trí luôn giữ bản máy chủ ở đó vì ô 0
           luôn đổi). Quá hạn chót 800 ms (lưới đã hiện) thì về cổng như LU2. */
        if (!theoDauMayChu && (CHUNG.dangAn() || duocDeLuoiMayChu(currentPage))) renderPage(currentPage);
        else firstPaint = false;
        giuMayChu = !luoiLaBanDaSap(currentPage);   // B2 vòng 2 (N2): hỏi lưới đang bày gì
        /* 🔴 6/9/2026 (vòng 43) — LƯỢT VẼ ĐẦU KHÔNG ĐỘNG VÀO THANH PHÂN TRANG.
           Xem khối chú thích ở cuối init(). */
        reveal();
        bindPagination();
        prefetchRest();
        return;
      }
      // Bộ đệm dở mà chưa đủ cho trang đang xem → đi tiếp từ chỗ đang dở.
    }

    /* Cold path — chỉ lấy vừa đủ cho trang đang xem.
       🔴 14/9/2026 (vòng 48) — GIEO TRƯỚC KHI ĐI XIN. Lưới máy chủ đang nằm trong
       DOM chính là trang 1; gieo nó vào cachedAll thì lô mạng đầu bắt đầu từ trang 2,
       và collection nào trang 1 đủ 24 món còn hàng thì KHÔNG đi mạng lần nào. Gọi ở
       đây là gọi SỚM NHẤT có thể mà vẫn nhường bộ đệm phiên đi trước: script mang
       `defer` nên lúc IIFE chạy `document.readyState` đã là 'interactive' ⇒ init()
       chạy NGAY, trước DOMContentLoaded, tức trước lượt paint của card-stepper và
       trước mọi người nghe `aef:cards-injected`. Thẻ chụp được là thẻ máy chủ gửi,
       chưa ai đụng vào. Xem khối chú thích ở gieoTuLuoi().
       🔴 24/10/2026 (B2) — tới được đây mà lưới còn đang ẩn (khối inline thấy bộ đệm đủ
       nhưng init() thì không: hết hạn đúng ở ranh giới, khoá lệch…) thì ĐỪNG bắt khách chờ
       một vòng mạng trong bóng tối: cho lưới máy chủ hiện NGAY, nhánh lạnh đi qua cổng
       vị trí như LU2. */
    CHUNG.hien();
    gieoTuLuoi();
    const ok = await ensureEnoughFor(currentPage);
    /* Một lượt init MỚI đã tiếp quản trong lúc chờ mạng (khách vừa lọc lần nữa) ⇒
       lượt này im lặng rút, đừng vẽ đè lên lưới của lượt sau. */
    if (luotCuaToi !== luot) return;
    // Bộ thủng: không sắp xếp, không ướp bộ đệm — để nguyên lưới máy chủ đã dựng.
    // Xếp thiếu 24 món tệ hơn nhiều so với xếp in-stock-trước trong từng trang.
    if (!ok || !cachedAll || !cachedAll.length) {
      reveal();
      return;
    }
    /* 🔴 14/9/2026 (vòng 48) — CHỈ ĐÈ KHI CÒN KỊP.
       Lượt ghi đè LẠNH: nó đè lên lưới mà máy chủ vừa vẽ và khách đang nhìn. Đo
       LIVE: đè muộn thì tới 24/24 thẻ đổi món dưới tay. Đầy đủ lý lẽ ở khối "KHÔNG
       THAY LƯỚI DƯỚI TAY KHÁCH" đầu tệp.
       🔴 23/10/2026 (LU2) — KHÔNG CÒN là lượt đè duy nhất (nhánh bộ đệm phía trên
       cũng đè lên lưới máy chủ), và "còn kịp" theo GIỜ không đủ: khách đã cuộn sẵn
       tới ô sắp đổi thì đè lúc nào cũng là đổi dưới mắt. Cả hai nhánh nay qua chung
       MỘT cổng duocDeLuoiMayChu() (giờ + chạm + vị trí; vị trí chỉ hỏi ở lượt tải trang). */
    if (!theoDauMayChu && duocDeLuoiMayChu(currentPage)) {
      renderPage(currentPage);
    } else {
      /* Máy chủ giữ trang này. Gỡ cờ firstPaint: lượt vẽ SAU không còn là "sắp lại
         thứ khách đang nhìn" nữa mà là nội dung MỚI do chính khách bấm, nên hiệu ứng
         nhả theo nhóm phải được chạy (xem chú thích trong renderPage). */
      firstPaint = false;
    }
    giuMayChu = !luoiLaBanDaSap(currentPage);   // B2 vòng 2 (N2): xem khối chú thích ở chỗ khai giuMayChu
    reveal();
    /* ══ 🔴 6/9/2026 (vòng 43) — LƯỢT VẼ ĐẦU KHÔNG ĐƯỢC VIẾT ĐÈ THANH PHÂN TRANG ══
     *
     * BẢN CŨ HỎNG THẾ NÀO. Ngay trên hai dòng này, init() gọi
     * `renderPagination(currentPage, totalPages())`. Nó dựng lại thanh bằng
     * `buildParts()` = tập {1, 2, current−1, current, current+1, total−1, total}.
     * Ở trang 1, tập đó ra {1,2,19,20} — KHÔNG có 3 — trong khi máy chủ vừa gửi
     * {1,2,3,…,20} (snippets/pagination.liquid in thẳng `paginate.parts` của
     * Shopify). Hai bản chụp LIVE cùng URL /collections/snacks, cùng 20 trang,
     * chứng minh cú đổi hình ĐÃ XẢY RA THẬT:
     *     máy chủ            : 1  2  3  …  20  →
     *     sau khi script chạy: 1  2  …  19  20  →
     * Khách đang đưa ngón tay tới ô "3" thì ô đó thành dấu "…" — một <span> không
     * bấm được. Số ô không đổi (6 <li> cả trước lẫn sau) nên không xê dịch; mất mát
     * thật là ĐÚNG MỘT liên kết bấm được, ở đúng trang 1.
     *
     * VÌ SAO BỎ HẲN LƯỢT VẼ NÀY LÀ ĐÚNG, chứ không phải "thêm current±2 vào tập".
     * init() chỉ được vào ĐÚNG SAU một lượt dựng của máy chủ — lúc tải trang, hoặc
     * khi khoiDongLai() chạy sau khi facets.js vừa thay nguyên ruột
     * #ProductGridContainer (thanh phân trang nằm trong đó). Cả hai lần, thanh trên
     * màn hình là bản máy chủ MỚI TINH và đã đúng trang đang xem. Sắp xếp lại
     * hàng-hết-xuống-cuối KHÔNG đổi tổng số trang (vẫn từng ấy sản phẩm — xem chú
     * thích ở totalPages()), nên không có gì để sửa. Vẽ lại ở đây là vẽ đè một câu
     * trả lời ĐÚNG bằng một câu trả lời KHÁC.
     * Còn thêm current±2 thì trang 1 ra 7 ô trong khi máy chủ có 6 ⇒ biến một cú
     * đổi chữ tại chỗ thành cú đổi BỀ RỘNG thật, và trang giữa vốn đã 9 ô số + 2 mũi
     * tên, thêm ô nữa là chắc chắn xuống hai dòng trên điện thoại.
     *
     * 🪤 THỨ KHÔNG ĐƯỢC MẤT: `bindPagination()` PHẢI Ở LẠI. Nó là thứ cướp cú bấm để
     * phân trang tức thì (<50ms, không vòng mạng). Bộ chọn của nó là
     * `.pagination-wrapper a.pagination__item` — lớp mà bản MÁY CHỦ cũng mang
     * (pagination.liquid:32 và cả hai mũi tên), nên nó bám được y như cũ.
     * `aria-label` cũng không mất: pagination.liquid:32/36 đã gắn sẵn từ khoá
     * general.pagination.page.
     *
     * navigateTo() và popstate VẪN gọi renderPagination — ở đó khách vừa bấm sang
     * trang khác, thanh BUỘC phải đổi theo, và không có bản máy chủ nào mới hơn.
     *
     * Người gác: scripts/test-thanh-phan-trang-khong-tu-doi-hinh.js */
    bindPagination();
    saveCache();
    prefetchRest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init().catch(reveal));
  } else {
    init().catch(reveal);
  }
})();
